<mat-option
  (onSelectionChange)="multiSelect().toggleSelectAll($event.source.selected)"
  [disabled]="multiSelect().filtered() || disabled"
  >Select all
</mat-option>
